import { render, staticRenderFns } from "./ContactItem.vue?vue&type=template&id=52d25d36&scoped=true&"
import script from "./ContactItem.vue?vue&type=script&lang=js&"
export * from "./ContactItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactItem.vue?vue&type=style&index=0&id=52d25d36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d25d36",
  null
  
)

export default component.exports